export enum CollectorStatus {
    new = 'WAITING_FOR_COLLECTOR_TO_ACCEPT',
    collectorAssigned = 'COLLECTOR_ASSIGNED',
    waitingForCollectorToAccept = 'WAITING_FOR_COLLECTOR_TO_ACCEPT',
    enRouteToMerchant = 'EN_ROUTE_TO_MERCHANT',
    collectorNearMerchant = 'COLLECTOR_NEAR_MERCHANT',
    waitingAtMerchant = 'WAITING_AT_MERCHANT',
    enRouteToMannaBase = 'EN_ROUTE_TO_MANNA_BASE',
    collectorNearLZ = 'COLLECTOR_NEAR_LZ',
    atMannaBase = 'AT_MANNA_BASE',
    handedOver = 'HANDED_OVER',
  }

function isValidOrderType(reason: string): reason is CollectorStatus {
    return Object.values(CollectorStatus).includes(reason as CollectorStatus);
}

export const convertToOrderType =(
    collectorStatus: string
): CollectorStatus | undefined => {
    if (isValidOrderType(collectorStatus)) {
        return collectorStatus as CollectorStatus;
    }
    return undefined;
}

export const getCollectorStatusAltTag = (collectorStatus: string): string => {
    const emoji = getEmojiForCollectorStatus(collectorStatus);
    const orderType = convertToOrderType(collectorStatus);
    let altTag = '';
    switch (orderType) {
        case CollectorStatus.new: {
            altTag = 'Waiting for Collector to Accept';
            break;
        }
        case CollectorStatus.collectorAssigned: {
            altTag = 'Collector Assigned';
            break;
        }
        case CollectorStatus.enRouteToMerchant: {
            altTag = 'En Route to Merchant';
            break;
        }
        case CollectorStatus.collectorNearMerchant: {
            altTag = 'Near Merchant';
            break;
        }
        case CollectorStatus.enRouteToMannaBase: {
            altTag = 'En Route to Base';
            break;
        }
        case CollectorStatus.collectorNearLZ: {
            altTag = 'Near Landing Zone';
            break;
        }
        case CollectorStatus.atMannaBase: {    
            altTag = 'At Base';
            break;
        }
        case CollectorStatus.waitingAtMerchant: {
            altTag = 'Waiting at Merchant';
            break;
        }
        case CollectorStatus.handedOver: {
            altTag = 'Handed Over';
            break;
        }
        default: {
            altTag = '';
        }
    }
    return `${emoji} ${altTag}`;
}

export const getEmojiForCollectorStatus = (collectorStatus: string): string => {

    const orderType = convertToOrderType(collectorStatus);

    switch (orderType) {
        case CollectorStatus.new: {
            return '⏳';
        }
        case CollectorStatus.enRouteToMerchant: {
            return '🛵';
        }
        case CollectorStatus.collectorNearMerchant: {
            return '📍';
        }
        case CollectorStatus.collectorAssigned: {
            return '🙋‍♂️';
        }
        case CollectorStatus.enRouteToMannaBase: {
            return '🚗';
        }
        case CollectorStatus.collectorNearLZ: {
            return '📍';
        }
        case CollectorStatus.atMannaBase: {    
            return '📦';
        }
        case CollectorStatus.waitingAtMerchant: {
            return '🕒';
        }
        case CollectorStatus.handedOver: {
            return '📬';
        }
        default: {
            return '⏳';
        }
    }
}

export const getDescriptionForCollectorStatus = (collectorStatus: string, collectorId: string): string => {

    const orderType = convertToOrderType(collectorStatus);

    switch (orderType) {
        case CollectorStatus.new: {
            return 'Waiting for Collector to Accept';
        }
        case CollectorStatus.collectorAssigned: {
            return `Assigned to ${collectorId}`;
        }
        case CollectorStatus.enRouteToMerchant: {
            return `${collectorId} heading to Merchant`;
        }
        case CollectorStatus.collectorNearMerchant: {
            return `${collectorId} near Merchant`;
        }
        case CollectorStatus.enRouteToMannaBase: {
            return `${collectorId} heading to Manna`;
        }
        case CollectorStatus.collectorNearLZ: {
            return `${collectorId} near Landing Zone`;
        }
        case CollectorStatus.atMannaBase: {
            return 'At Base';
        }
        case CollectorStatus.waitingAtMerchant: {
            return 'Waiting at Merchant';
        }
        case CollectorStatus.handedOver: {
            return 'With Manna';
        }
        default: {
            return 'No Collector';
        }
    }
}